import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { LoadingSpinnerPage } from '../../atomic/Loaders/LoadingSpinner';

const Container = styled.div`
  display: flex;
  position: fixed;
  height: 100vh;
  width: 100vw;
  z-index: 99999;
`

const Overlay = styled.div`
  position: absolute;
  flex: 1;
  background: rgba(0,0,0,0.06);
  height: 100%;
  width: 100%;
`

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: rgba(0,0,0,0.75);
  width: 180px;
  height: 180px;
  margin: auto;
  color: white;
  border-radius: 20px;
`

const LoadingSpinnerStyled = styled(LoadingSpinnerPage)`
  // margin-bottom: 30px;
`
const TextContainer = styled.div`
  text-align: center;
  flex: 1;
  font-weight: 600;
  font-size: 22px;
  margin-bottom: 16px;
`

const FloatingSelect = ({
  children,
  globalUIState,
  ...other
}) => {
  const { isLoadingSpinner, spinnerText } = globalUIState;

  return isLoadingSpinner ? (
    <Container {...other}>
      <Overlay/>
      <Wrapper>
        <LoadingSpinnerStyled color='inherit' />
        <TextContainer>
          {spinnerText}
        </TextContainer>
      </Wrapper>
    </Container>
  ) : null;
}

FloatingSelect.propTypes = {

};

FloatingSelect.defaultProps = {

};

function mapStateToProps(state) {
  return {
    globalUIState: state.globalUIState,
  };
}

export default connect(mapStateToProps,null)(FloatingSelect);
